import { reactive } from 'vue';

const death = reactive({
  message: '',
  show,
});

function show(error) {
  death.message = !error.response ? error.message : error.response.data.message;
}

export default death;
